import { Building2, Globe2, Users, Target, CheckCircle2 } from "lucide-react";

export const COMPANY_STEPS = [
  { id: 1, title: "Company Info", icon: Building2 },
  { id: 2, title: "Business Profile", icon: Globe2 },
  { id: 3, title: "Size & Revenue", icon: Users },
  { id: 4, title: "Markets & Objectives", icon: Target },
  { id: 5, title: "Summary", icon: CheckCircle2 },
];
